import React from 'react';

import { formatCurrency } from '../../helpers/format-helper';

export default function InstallmentItem({ installment, isSelected, onInstallmentClick }) {

    const { cantCuotas, valorCuota } = installment;

    return (
        <div
            onClick={() => onInstallmentClick(installment)}
            className={`installments__item ${isSelected ? 'installments__item--selected' : ''}`}>
            <div>{cantCuotas} cuotas de</div>
            <div className="installments__amount">{formatCurrency(valorCuota)}</div>
        </div>
    );

}
